export const userAuthTypes = {
  USER_RESET_PASSWORD_REQUEST: 'USER_RESET_PASSWORD_REQUEST',
  USER_RESET_PASSWORD_SUCCESS: 'USER_RESET_PASSWORD_SUCCESS',
  USER_RESET_PASSWORD_ERROR: 'USER_RESET_PASSWORD_ERROR',

  USER_GET_RESET_PASSWORD_REQUEST: 'USER_GET_RESET_PASSWORD_REQUEST',
  USER_GET_RESET_PASSWORD_SUCCESS: 'USER_GET_RESET_PASSWORD_SUCCESS',
  USER_GET_RESET_PASSWORD_ERROR: 'USER_GET_RESET_PASSWORD_ERROR',
};
